import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {injectIntl, FormattedMessage} from "react-intl";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {useFormikContext} from "formik";

import Label from "components/input/new/Label";
import {CKEditorConfig} from "components/input/inputRenderer/wysiwygInputRenderer";
import CustomButton from "components/CustomButton";
import SparkleIcon from "components/icons/SparkleIcon";

import DescriptionScore from "./DescriptionScore";
import DescriptionOptimizationDialog from "../../DescriptionOptimizationDialog";
import DescriptionVersionDropdown from "../../DescriptionVersionDropdown";
import LockFieldButton from "../../../../LockFieldButton";

import {UserAgentUtils} from "utils/useragent";

DescriptionField.propTypes = {
    localeCode: PropTypes.string.isRequired
};

function DescriptionField({localeCode, ...props}) {
    const {values, setFieldValue} = useFormikContext();

    const [optimizationDialog, setOptimizationDialog] = useState({open: false, action: 'seo'});

    function openOptimizationDialog(action) {
        setOptimizationDialog({open: true, action});
    }

    function closeOptimizationDialog() {
        setOptimizationDialog((current) => ({...current, open: false}));
    }

    const cloneConfig = {...CKEditorConfig};

    const customCKEditorConfig = Object.assign(cloneConfig, {
        toolbar: {items: CKEditorConfig.toolbar, shouldNotGroupWhenFull: true},
        link: {addTargetToExternalLinks: true},
    });

    const initialDescription = (values.translations?.[localeCode]?.description ?? '').replace(/\n/g, '<br/>');

    function lockButtonContainerStyle() {
        if (UserAgentUtils.isMobile()) {
            return {
                position: 'absolute',
                top: '-29px',
                left: '64px'
            }
        } else {
            return {
                position: 'absolute',
                top: '4px',
                right: '8px'
            }
        }
    }

    return (
        <>
            <Label htmlFor={`translations.${localeCode}.description`}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '4px',
                    marginBottom: '8px',
                }}>
                    <FormattedMessage id='product.show.product.form.field.description' />
{/*
                    <DescriptionScore score={10} /> // TODO we don't have this score yet
*/}
                   {/* <DescriptionVersionDropdown /> */}
                </div>
            </Label>

            {/*<div style={{
                display: 'flex',
                gap: '8px',
                marginBottom: '8px',
                flexWrap: 'wrap',
            }}>
                <CustomButton variant='contained' color='lightBlue' onClick={() => openOptimizationDialog('seo')}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <SparkleIcon size={16} />
                        <FormattedMessage id='product.show.product.form.field.description.optimization.type.seo' />
                    </div>
                </CustomButton>
                <CustomButton variant='contained' color='lightBlue' onClick={() => openOptimizationDialog('gso')}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <SparkleIcon size={16} />
                        <FormattedMessage id='product.show.product.form.field.description.optimization.type.gso' />
                    </div>
                </CustomButton>
                <CustomButton variant='contained' color='lightBlue' onClick={() => openOptimizationDialog('seoGso')}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <SparkleIcon size={16} />
                        <FormattedMessage id='product.show.product.form.field.description.optimization.type.seoGso' />
                    </div>
                </CustomButton>
            </div>*/}
            <div style={{position: "relative", width: '100%'}}>
                <CKEditor
                    name={`translations.${localeCode}.description`}
                    type={"wysiwyg"}
                    config={customCKEditorConfig}
                    editor={ClassicEditor}
                    data={initialDescription}
                    placeholder={(<FormattedMessage id='product.show.product.form.field.description.placeholder' />)}
                    onChange={( event, editor ) => {
                        setFieldValue(`translations.${localeCode}.description`, editor.getData());
                    }}
                />
                <div style={lockButtonContainerStyle()}>
                    <LockFieldButton
                        isLocked={values.productLock?.description}
                        onClick={() => setFieldValue('productLock.description', !values.productLock?.description)}
                    />
                </div>
            </div>

            {/*<DescriptionOptimizationDialog
                open={optimizationDialog.open}
                action={optimizationDialog.action}
                onClose={closeOptimizationDialog}
            />*/}
        </>
    );
}

export default injectIntl(DescriptionField);
